import { render, staticRenderFns } from "./LanguageCard.vue?vue&type=template&id=4c2226b8&scoped=true&lang=html"
import script from "./LanguageCard.vue?vue&type=script&lang=ts"
export * from "./LanguageCard.vue?vue&type=script&lang=ts"
import style0 from "./LanguageCard.vue?vue&type=style&index=0&id=4c2226b8&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2226b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2226b8')) {
      api.createRecord('4c2226b8', component.options)
    } else {
      api.reload('4c2226b8', component.options)
    }
    module.hot.accept("./LanguageCard.vue?vue&type=template&id=4c2226b8&scoped=true&lang=html", function () {
      api.rerender('4c2226b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LanguageCard.vue"
export default component.exports